module.exports = __webpack_public_path__ + "static/media/logo.dae439d1.png";